var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blocks-wrapper"},_vm._l((_vm.blocks),function(block,index){return _c('app-text',{key:index,staticClass:"block",attrs:{"text":block}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }